<template>

	<b-row>

		<!--<p v-for="user of users">{{user.username}}</p>-->
		<b-col cols="12" xl="12">

			<transition name="slide">

				<b-card>

					<div slot="header" class="d-flex justify-content-between custom-card-header">
						<h5 class="card-header-title"> {{ $t('permissions.title') }}</h5>
						<div class="searchInCard">
							<b-input-group size="sm">
								<b-form-input v-model="filter" size="sm" :placeholder="$t('contragent.filter')"/>
								<b-input-group-append>
									<b-button :disabled="!filter" @click="filter = ''">{{$t('contragent.clear')}}
									</b-button>
								</b-input-group-append>
							</b-input-group>
						</div>
					</div>

					<b-table class="generalTableClass" :hover="hover" :striped="striped" :bordered="bordered"
							 :small="small" :fixed="fixed"
							 :filter="filter"
							 responsive="sm" :items="permissions" :fields="computedFields" :current-page="currentPage"
							 :per-page="perPage" show-empty>

						<!-- EMPTY SLOT FOR TABLE -->
						<template slot="empty" slot-scope="scope">
							<h4>{{ $t('empty') }}</h4>
						</template>
						<!-- EMPTY SLOT FOR TABLE -->

						<template slot="id" slot-scope="data">
							<strong>{{data.item.id}}</strong>
						</template>
						<template slot="name" slot-scope="data">
							<p v-bind:key="data.item.id + 'type'"
							   v-if="focusedData.id != data.item.id || focusedData.key != data.field.key"
							   @dblclick="changeFocused(data)" v-b-tooltip.hover
							   :title="$t('actions.update')">{{ data.value ? data.value : '&emsp;&emsp;&emsp;'
								}}</p>
							<b-form-input autofocus ref="roleNameRef"
										  @focusout.native="inputUnfocused(data, data.value)"
										  @keydown.enter="inputUnfocused(data, data.value)"
										  v-bind:key="data.item.id + 'type'" v-model="data.value"
										  v-if="focusedData.key === data.field.key && focusedData.id === data.item.id"></b-form-input>
						</template>
						<template slot="type" slot-scope="data" class="col-md-8">
							<p v-bind:key="data.item.id + 'type'"
							   v-if="focusedData.id != data.item.id || focusedData.key != data.field.key"
							   @dblclick="changeFocused(data)" v-b-tooltip.hover
							   :title="$t('actions.update')">{{ data.value ? data.value : '&emsp;&emsp;&emsp;'
								}}</p>
							<b-form-input autofocus ref="roleTypeRef"
										  @focusout.native="inputUnfocused(data, data.value)"
										  @keydown.enter="inputUnfocused(data, data.value)"
										  v-bind:key="data.item.id + 'type'" v-model="data.value"
										  v-if="focusedData.key == data.field.key && focusedData.id == data.item.id"></b-form-input>
						</template>
						<template slot="code" slot-scope="data">
							<strong>{{data.item.code}}</strong>
						</template>
						<template slot="sort" slot-scope="data" class="col-md-8">
							<p v-bind:key="data.item.id + 'sort'"
							   v-if="focusedData.id != data.item.id || focusedData.key != data.field.key"
							   @dblclick="changeFocused(data)" v-b-tooltip.hover
							   :title="$t('actions.update')">{{ data.value ? data.value : '&emsp;&emsp;&emsp;'
								}}</p>
							<b-form-input autofocus ref="roleSortRef"
										  type="number"
										  @focusout.native="inputUnfocused(data, data.value)"
										  v-on:keyup.enter="inputUnfocused(data, data.value)"
										  v-bind:key="data.item.id + 'sort'" v-model="data.value"
										  v-if="focusedData.key == data.field.key && focusedData.id == data.item.id"></b-form-input>
						</template>

						<!--<template slot="sort" slot-scope="data">-->
						<!--<strong>{{data.item.sort}}</strong>-->
						<!--</template>-->

					</b-table>
					<nav>
						<b-pagination :total-rows="permissions.length" :per-page="perPage" v-model="currentPage"
									  :prev-text="$t('pagination.prev')"
									  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
					</nav>
				</b-card>
			</transition>
		</b-col>
	</b-row>
</template>

<script>
	import permissionsData from './PermissionsData'
	import {mapActions, mapGetters} from "vuex";

	export default {
		name: 'Permissions',

		props: {
			caption: {
				type: String,
				default: 'Permissions'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},
		data: () => {
			return {
				filter:'',
				focusedData: {id: null, key: null},
				permField: [
					{
						key: 'id',
						sortable: true
					},
					{
						key: 'name',
						'class': 'width30_wordBreak',
						sortable: true
					},
					{
						key: 'type',
						'class': 'width15_wordBreak'
					},
					{key: 'code'},
					{
						key: 'sort',
						'class': 'perm_sort',
						sortable: true
					},
				],
				item: {
					name: '',
					code: '',
					// type: '',

				},
				currentPage: 1,
				perPage: 20,
				totalRows: 0,


			}

		},
		computed: {
			...mapGetters('permissions', [
				'permissions'
			]),
			computedFields() {
				return [
					{
						key: 'id',
						label: "Id",
						'class': 'role_id',
						sortable: true
					},
					{
						key: 'name',
						label: this.$t('permissions.name'),
						'class': 'width30_wordBreak',
						sortable: true
					},
					{
						key: 'type',
						label: this.$t('permissions.type'),
						'class': 'width30_wordBreak',
						sortable: true
					},
					{
						key: 'code',
						label: this.$t('permissions.code')
					},
					{
						key: 'sort',
						label: this.$t('permissions.sort'),
						'class': 'perm_sort',
						sortable: true
					},

				]
			}
		},

		async mounted() {
			this.fetchPerm();
		},
		methods: {
			getBadge(status) {
				return status === 'Active' ? 'success'
					: status === 'Inactive' ? 'secondary'
						: status === 'Pending' ? 'warning'
							: status === 'Banned' ? 'danger' : 'primary'
			},
			...mapActions('permissions', [
				'fetchPerm', 'editPermission'
			]),
			async inputUnfocused(data, newName) {
				let newPerm = {...data.item};
				if (data.field.key == 'sort') {
					newPerm.sort = newName;
					if (data.item.sort != newName) {
						await this.editPermission(newPerm);
						this.fetchPerm();
					}
				}
				if (data.field.key == 'type') {
					newPerm.type = newName;
					if (data.item.type != newName && newName.trim() != '') {
						await this.editPermission(newPerm);
						this.fetchPerm();
					}
				}``
				if (data.field.key == 'name') {
					newPerm.name = newName;
					if (data.item.name != newName && newName.trim() != '') {
						await this.editPermission(newPerm);
						this.fetchPerm();
					}
				}
				this.focusedData.id = null;
				this.focusedData.key = null
			},
			changeFocused(data) {
				this.focusedData.id = data.item.id;
				this.focusedData.key = data.field.key;
				setTimeout(() => {

					if (data.field.key == 'sort') {
						this.$refs["roleSortRef"].$el.focus()

					}
					if (data.field.key == 'type') {
						this.$refs["roleTypeRef"].$el.focus()

					}
					if (data.field.key == 'name') {
						this.$refs["roleNameRef"].$el.focus()

					}
				}, 50)
			},
		}
	}
</script>

<style scoped>
	.card-body >>> table > tbody > tr > td {
		cursor: pointer;
	}
</style>
